// Jinx — Fishbones: every 3 autos she fires a burst of 3 rockets at the target.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const jinxFishbones: Ability = {
  id: "jinxFishbones",
  displayName: "Fishbones",
  description: "Every 3rd attack fires 3 rapid rockets, each dealing 0.8× AD physical damage.",
  iconId: "JinxQ",

  targetShape({ target }) {
    return [target.pos];
  },

  computeHits({ caster, target }): AbilityHit[] {
    const stats = effectiveStats(caster);
    const shotDmg = physicalDamage(stats.ad * 0.8);
    return [
      { target, amount: shotDmg, type: "physical", jinxRocket: true, retargetIfDead: true },
      { target, amount: shotDmg, type: "physical", jinxRocket: true, retargetIfDead: true },
      { target, amount: shotDmg, type: "physical", jinxRocket: true, retargetIfDead: true },
    ];
  },
};
